<form class="login-form"
      #formRef="ngForm"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmitForm(formGroup.value)">
    <div class="form-section">
        <div class="row">
            <mat-form-field class="field">
                <mat-label>Username</mat-label>
                <input matInput
                       #username="matInput"
                       type="text"
                       formControlName="username"
                       autocomplete="on"
                       id="username"
                       name="username">
                <mat-error *ngIf="formGroup.get('username').hasError('required')">
                    Field is required.
                </mat-error>
            </mat-form-field>
        </div>

        <div [@expandCollapse]
             *ngIf="hasStartedReset">
            <div class="message-row">
                <p class="message-line">
                    A verification code has been sent to <span class="email-address">{{maskedEmailAddress}}</span>.
                </p>
                <p class="message-line">
                    If you don't recognize the email address or haven't received a code after 10 minutes, please contact customer service.
                </p>
            </div>

            <div class="row">
                <mat-form-field class="field">
                    <mat-label>Verification Code</mat-label>
                    <input matInput
                           #verificationCode="matInput"
                           type="text"
                           formControlName="verificationCode"
                           autocomplete="off">
                    <mat-error *ngIf="formGroup.get('verificationCode').hasError('required')">
                        Field is required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <hq-password-field class="field password-field"
                                   placeholder="New Password"
                                   [shouldDisplayRequirements]="true"
                                   [submitted]="hasFormBeenSubmitted"
                                   (markAsInitialized)="onAttachChildForm('password', $event)">
                </hq-password-field>
            </div>
        </div>

        <div class="row button-container">
            <button mat-raised-button
                    type="submit"
                    class="button"
                    color="accent"
                    [disabled]="isSubmissionInProgress">
                {{formButtonText}}
            </button>
        </div>
    </div>
</form>

<p class="login-link">
    <a [routerLink]="logInRoute">Return to Login</a>
</p>
